import React, { useState } from 'react';
import { X, MessageSquare } from 'lucide-react';
import './ScriptFeedbackModal.css';

function ScriptFeedbackModal({ script, isOpen, onClose, onSubmitFeedback }) {
  const [feedbackText, setFeedbackText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!feedbackText.trim() || !onSubmitFeedback || !script) return;
    setIsSubmitting(true);
    try {
      await onSubmitFeedback(script, feedbackText.trim());
      setFeedbackText('');
      onClose();
    } catch (e) {
      console.error('Failed to submit feedback:', e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setFeedbackText('');
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="script-feedback-modal-overlay" onClick={handleClose}>
      <div className="script-feedback-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="script-feedback-modal-header">
          <div className="script-feedback-modal-title-row">
            <MessageSquare size={24} className="script-feedback-modal-icon" />
            <h3 className="script-feedback-modal-title">Give feedback to your account manager</h3>
          </div>
          <button className="script-feedback-modal-close" onClick={handleClose} aria-label="Close">
            <X size={20} />
          </button>
        </div>

        <div className="script-feedback-modal-body">
          {script && (
            <p className="script-feedback-script-name">
              Script: <strong>{script.name || script.title || `Script ${script.id}`}</strong>
            </p>
          )}
          <p className="script-feedback-desc">
            Share changes or suggestions. Your account manager will review and update the script accordingly. The script will be removed from your pending list until they make updates.
          </p>
          <textarea
            className="script-feedback-textarea"
            placeholder="Describe the changes or feedback you'd like (e.g. tone adjustment, different hook, more focus on benefits...)"
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            rows={5}
            disabled={isSubmitting}
          />
        </div>

        <div className="script-feedback-modal-footer">
          <button
            type="button"
            className="script-feedback-cancel-btn"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="script-feedback-submit-btn"
            onClick={handleSubmit}
            disabled={!feedbackText.trim() || isSubmitting}
          >
            {isSubmitting ? 'Submitting…' : 'Submit feedback'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ScriptFeedbackModal;
